<template>
  <svg
    width="345"
    height="204"
    viewBox="0 0 345 204"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9258_16468)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M143.581 102.582C106.347 100.486 76.718 72.5722 71.2382 37.2711C71.0039 39.5989 70.8129 41.9482 70.6649 44.2976C67.3301 103.661 102.461 156.297 154.456 178.116C168.581 184.042 183.937 187.704 200.121 188.613C275.841 192.846 340.687 135.09 344.935 59.6203C344.957 59.155 344.978 58.6898 344.998 58.223C330.895 52.2975 315.517 48.6353 299.353 47.7463C214.904 43.0262 203.541 105.926 143.58 102.582H143.581Z"
        fill="#1F5668"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M71.2382 37.2712C72.81 47.4085 76.3775 56.9532 81.5614 65.4399C83.3875 68.4448 85.4063 71.3024 87.6146 74.0325C121.874 69.5888 149.593 42.7314 154.393 7.98002C123.318 -0.379225 90.2482 11.1754 71.2382 37.2712Z"
        fill="#2A88A6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M71.2382 37.2712C56.2009 12.5728 28.8648 -1.60755 0 0.149063C1.42236 40.3607 33.3461 71.8737 72.2999 74.4978C70.6649 64.7198 70.0917 54.6039 70.6649 44.2977C70.7928 41.9484 71.0055 39.5991 71.2382 37.2712Z"
        fill="#2A88A6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.8231 8.8045C28.5042 2.37077 14.4424 -0.74015 0 0.148903C0.892249 25.566 13.9971 47.4929 33.3261 60.8671C-1.16809 0.276345 40.8015 8.78454 40.8231 8.8045Z"
        fill="#5EFAF7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M72.2999 74.4977C81.5815 106.011 110.596 147.808 172.891 141.565L188.588 157.883L227.223 101.926L179.22 95.7674C168.962 100.507 157.598 103.365 143.58 102.582C120.831 101.312 100.909 90.3916 87.613 74.0325C83.1733 68.5722 79.5211 62.5408 76.7165 56.1071C74.1676 50.2875 72.3415 44.0857 71.2998 37.6519C71.2782 37.5245 71.2567 37.3986 71.2366 37.2711C71.0024 39.5989 70.7913 41.9482 70.6634 44.2976C70.0901 54.6038 70.6634 64.7212 72.2984 74.4977H72.2999Z"
        fill="#0E607A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M122.576 202.792C273.252 219.025 207.344 66.3274 345 58.2215C330.897 52.296 315.519 48.6338 299.355 47.7448C234.658 44.1256 212.845 80.2098 179.222 95.7659C200.462 108.464 152.821 186.03 122.576 202.792Z"
        fill="#2C687C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M295.065 70.7726C308.022 63.9995 324.185 59.4498 345 58.2229C330.897 52.2975 315.519 48.6353 299.355 47.7462C234.658 44.1271 212.845 80.2113 179.222 95.7674C186.317 100.001 185.722 111.492 180.666 125.502C180.666 125.502 182.259 197.268 219.683 139.534C219.683 139.534 279.26 23.0478 295.063 70.7511V70.7726H295.065Z"
        fill="#5EFAF7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M269.513 90.5191C285.295 73.2923 307.64 60.4248 345 58.2229C330.897 52.2975 315.519 48.6353 299.355 47.7462C234.658 44.1271 212.845 80.2113 179.222 95.7674C194.409 104.847 174.4 147.025 150.718 176.485H150.739C150.739 176.485 152.12 212.189 182.259 167.808C182.259 167.808 265.01 37.2496 269.513 90.4976V90.5191Z"
        fill="#51F5EA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M345 58.223C208.13 60.6568 270.618 214.497 122.576 202.793C159.767 206.793 183.768 200.507 200.887 188.656C253.115 152.444 241.306 64.3404 345 58.223Z"
        fill="#51F5EA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M72.6405 74.7096C77.9077 92.5721 89.5254 113.757 109.959 127.62C81.4335 94.1598 98.6806 95.5356 98.6806 95.5356C138.527 123.81 179.923 96.1912 179.923 96.1912V96.0223L179.562 95.9793C169.304 100.741 157.94 103.577 143.922 102.794C121.173 101.524 101.251 90.6036 87.9551 74.2444C83.5155 68.7841 79.8632 62.7527 77.0586 56.319C74.5097 50.4994 72.6836 44.2976 71.6419 37.8638C71.6203 37.7364 71.5988 37.6105 71.5787 37.483C71.3445 39.8108 71.1534 42.1602 71.0055 44.531C70.4322 54.8372 71.0055 64.9331 72.6405 74.7112V74.7096Z"
        fill="#5EFAF7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M127.205 107.406C127.162 105.416 126.673 102.857 125.696 99.5755C118.942 97.544 112.613 94.6235 106.814 90.9613C99.4866 86.4116 93.0081 80.6551 87.613 74.0309C83.8329 69.3753 80.6045 64.3174 78.0125 58.9416C77.7151 58.3274 77.4177 57.7147 77.1418 57.079C76.9939 56.7612 76.8444 56.4449 76.7165 56.1055C74.2956 50.5824 72.5326 44.7198 71.4709 38.6239C71.2798 40.5709 71.1303 42.5394 71.0039 44.5279C70.4307 54.8341 71.0039 64.93 72.639 74.7081C74.5082 81.0359 77.1634 87.766 80.7308 94.4546C78.7137 88.3172 85.2553 92.1268 94.0052 97.8618C107.959 106.963 127.564 120.951 127.203 107.406H127.205ZM71.6419 39.6189C72.7253 45.3325 74.425 50.8572 76.718 56.1055C74.4235 50.8787 72.7253 45.354 71.6419 39.6189Z"
        fill="#5EFAF7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M332.616 109.185C339.625 94.0108 343.937 77.3123 344.935 59.6187C344.957 59.1535 344.978 58.6882 344.998 58.2214C344.935 58.2429 344.851 58.2429 344.786 58.2429C324.056 59.4913 307.977 64.0425 295.063 70.7726V70.7511C284.762 76.1269 276.5 82.8984 269.512 90.5175V90.496C242.049 120.486 234.594 163.765 202.818 187.257C232.299 171.49 310.546 47.7877 332.615 109.183L332.616 109.185Z"
        fill="#2A88A6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M135.956 48.2115C145.642 37.1851 152.268 23.3657 154.393 7.97844C123.405 -0.360846 90.4393 11.1109 71.4092 37.0362L71.7698 37.2696C71.7698 37.2696 156.517 -6.00994 135.956 48.2115Z"
        fill="#5EFAF7"
      />
    </g>
    <defs>
      <clipPath id="clip0_9258_16468">
        <rect width="345" height="204" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
